// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesLineReturn"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}

const fields = {
  fields: [
    {
      key: "sales_order_num",
      label: "平台销售订单编号",
      sortable: true,
      isRowHeader: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "Cust_SEI_Name",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },
    {
      key: "ConfirmedDlv",
      label: "装运日期",
      type: "date"
    },
    {
      key: "TEC_Remark",
      label: "备注",
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },
    {
      key: "LineNum",
      label: "行号",
      type: "",
      isRowHeader: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "SalesQty",
      label: "订单数量",
      type: "number",
      _precise: 6
    },
    {
      key: "SalesValidRemain",
      label: "剩余派单数量",
      type: "number",
      _precise: 6
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      type: "date"
    },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      type: "date"
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },
    {
      key: "TEC_OtherInfo",
      label: "其他信息",
      thStyle: {
        width: "12rem"
      },
      type: "short"
    },

    {
      key: "hasPriceConfirmState",
      label: "实际采购价确认",
      type: "button",
      isRowHeader: true,
      button: {
        type: "danger",
        base_field_key: "hasPriceConfirm"
      },
      thStyle: {
        width: "120px"
      },
      formatter: (value, key, item) => {
        if (item.hasPriceConfirm) {
          item.hasPriceConfirmState = "有"
        }
        else {
          item.hasPriceConfirmState = "无"
        }
      }
    },

    {
      key: "hasInitPriceState",
      label: "采购初始报价",
      type: "button",
      isRowHeader: true,
      button: {
        type: "danger",
        base_field_key: "hasInitPrice"
      },
      thStyle: {
        width: "120px"
      },
      formatter: (value, key, item) => {
        if (item.hasInitPrice) {
          item.hasInitPriceState = "有"
        }
        else {
          item.hasInitPriceState = "无"
        }
      }
    },

    {
      key: "SOApprover",
      label: "订单待审批人"
    },
    {
      key: "fcCheckSOApproved",
      label: "订单审批状态",
      type: "state",
      other_type_key: "is_email_send",
      state_control: "fcCheckSOApproved",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SOCreditControlApprover",
      label: "信用待审批人"
    },
    {
      key: "fcCheckSOCreditControlApproved",
      label: "信用审批状态",
      type: "state",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "approved_comment",
      label: "信用控制意见"
    },
    {
      key: "SOPriceDiffApprover",
      label: "价格待审批人"
    },
    {
      key: "fcCheckSOPriceDffApproved",
      label: "价格审批状态",
      type: "state",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "create_by",
      label: "创建人",
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "date"
    },
    {
      key: "update_by",
      label: "修改人",
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      type: "date"
    }
  ],
  dicpatch_fields: [
    {
      key: "idnum",
      label: "派发编号",
      sortable: true,
      width: "60px",
      formatter: (value, key, item) => {
        return item.id
      }
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "qty",
      label: "数量",
      editable: false,
      type: "just_number"
      // _precise: 6
    },
    {
      key: "price",
      label: "实际含税价",
      editable: false,
      type: "just_number"
    },
    {
      key: "PurchCurrencyCode",
      label: "实际含税价币种"
    },
    {
      key: "price_wotax",
      label: "实际采购本币净单价",
      type: "number",
      _precise: 6
    },
    {
      key: "price_remark",
      label: "价格备注",
      width: "8rem",
      type: "short"
    },
    {
      key: "price_vend",
      label: "初始含税报价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_vend_currency",
      label: "初始含税报价币种",
    },
    {
      key: "price_vend_wotax",
      label: "初始采购本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },

    {
      key: "VendTaxGroup",
      label: "供应商税组",
      sortable: true,
      thStyle: {
        width: "150px"
      }
    },

    {
      key: "Cost_Sum",
      label: "供应商成本",
      type: "number"
    },

    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: false,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "number"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "create_by_username",
      label: "派发创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "Approver",
      label: "当前审批人",
      sortable: true
    },

    {
      key: "fcCheckDocumentAllApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentAllApproved",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中", "已退回"]
    },
    {
      key: "SDApprovedState",
      label: "审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSDApproved) {
          item.SDApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SDApprovedState = "审批中"
          return "审批中"
        } else {
          item.SDApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "isAXError",
      label: "异常状态",
      sortable: true,
      type: "state_error",
      context: ["", "异常"]
    },
    {
      key: "AXError",
      label: "异常信息",
      sortable: true,
      type: "short",
    }
  ]
}


const dataForm = {
  return_qty: 0,
  return_description: ""
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const rules = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  async getData(_params) {
    let _fields = _.map(fields, (t) => {
      return t.key
    })
    console.log(_fields)
    const biz_data = new biz_data_helper.base_entity_helper(
      "getPurchNotPerform",
      {},
      {}
    )
    let result = await biz_data
      .execAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

}
export { biz_data, dataForm, fields, methods, rules };

